<template>
  <main class="main internet_item_view" role="main" v-if="isCompleted">
    <div class="header_btn" v-if="!promotionCheck">
      <i
        class="pnt"
        :class="
          `i_h_like_${internetProduct.isBookmark === 'Y' ? 'on' : 'off'}_big`
        "
        @click="toggleBookmark"
      ></i>
      <!-- <i class="i_share pnt"></i> -->
    </div>
    <div class="main_con">
      <div>
        <div class="item_sec_1">
          <div class="top_sec">
            <div class="logo">
              <img
                v-if="internetProduct.telecomLogo"
                :src="internetProduct.telecomLogo"
                alt=""
              />
            </div>
            <div>
              <span class="my_area" v-if="internetProduct.setArea"
                ><i class="i_mytown"></i>{{ internetProduct.setArea }}</span
              >
              <span v-if="internetProduct.internetSpeed">{{
                isInternetSpeed(internetProduct.internetSpeed)
              }}</span>
              <span v-if="internetProduct.channelCount"
                >{{ internetProduct.channelCount }}ch</span
              >
            </div>
          </div>
          <div class="con_sec">
            <div
              class="con_inner"
              v-if="internetProduct.internetId || internetProduct.wifiId"
            >
              <img
                :src="
                  require('@/assets/front/images/new/i_main_my_internet.svg')
                "
                alt=""
              />
              <div class="con">
                {{ internetProduct.internetName
                }}<span class="color" v-if="internetProduct.internetId"
                  >({{ formatNumber(internetProduct.internetPrice) }}원)</span
                >
                <p>
                  {{
                    internetProduct.internetId && internetProduct.wifiId
                      ? '+'
                      : ''
                  }}
                  {{ internetProduct.wifiName
                  }}<span class="color" v-if="internetProduct.wifiId"
                    >({{ formatNumber(internetProduct.wifiPrice) }}원)</span
                  >
                </p>
              </div>
            </div>
            <div
              class="con_inner"
              v-if="internetProduct.tvId || internetProduct.settopId"
            >
              <img
                :src="require('@/assets/front/images/new/i_main_my_tv.svg')"
                alt=""
              />
              <div class="con">
                {{ internetProduct.tvName
                }}<span class="color" v-if="internetProduct.tvId"
                  >({{ formatNumber(internetProduct.tvPrice) }}원)</span
                >
                <p>
                  {{
                    internetProduct.tvId && internetProduct.settopId ? '+' : ''
                  }}
                  {{ internetProduct.settopName
                  }}<span class="color" v-if="internetProduct.settopId"
                    >({{ formatNumber(internetProduct.settopPrice) }}원)</span
                  >
                </p>
                <!-- <p class="desc"></p> -->
              </div>
            </div>
          </div>
          <div class="price_sec">
            <del>{{ formatNumber(internetProduct.totalPrice) }}원</del>
            <p>
              <span class="grey border">3년 약정</span>월
              <span class="red emp">{{
                formatNumber(internetProduct.realPrice)
              }}</span
              >원
            </p>
            <p class="sm">
              설치비
              <span
                class="grey"
                v-if="
                  isWeekCost(
                    internetProduct.telecomId,
                    internetProduct.installCost,
                    internetProduct.installCostWeekend,
                  )
                "
                >(주중)</span
              >
              <span class="red">{{
                formatNumber(internetProduct.installCost)
              }}</span
              >원
              <span
                class="grey"
                v-if="
                  isWeekCost(
                    internetProduct.telecomId,
                    internetProduct.installCost,
                    internetProduct.installCostWeekend,
                  )
                "
                >(주말)</span
              >
              <span
                class="red"
                v-if="
                  isWeekCost(
                    internetProduct.telecomId,
                    internetProduct.installCost,
                    internetProduct.installCostWeekend,
                  )
                "
                >{{ formatNumber(internetProduct.installCostWeekend) }}</span
              ><span
                v-if="
                  isWeekCost(
                    internetProduct.telecomId,
                    internetProduct.installCost,
                    internetProduct.installCostWeekend,
                  )
                "
                >원</span
              >
            </p>
          </div>

          <div class="promotion_sec" v-if="promotionCheck">
            <div class="sec_1">
              <div class="sec_1_top">
                <div class="info_1">
                  <div class="shop_img">
                    <!-- <img
                        :src="
                          setShopProfileImg(s_item.storeName, s_item.storeId)
                        "
                        alt=""
                      /> -->
                    <img :src="setShopProfileImg('스마트윌', '305')" alt="" />
                  </div>
                  <div class="shop_info">
                    <div class="txt">퍼스우수매장</div>
                    <div class="name">스마트윌</div>
                  </div>
                </div>
                <div class="info_2">
                  <div class="support_info">
                    <div class="title">확정지원금</div>
                    <div class="price">
                      {{
                        getNumberToKorean(
                          internetSupport.cashSupport +
                            internetSupport.giftCardSupport +
                            internetSupport.perceSupport,
                        )
                      }}<span>만원</span>
                    </div>
                  </div>
                  <div class="support_txt">
                    매장지원
                    {{
                      getNumberToKorean(
                        internetSupport.cashSupport +
                          internetSupport.giftCardSupport,
                      )
                    }}
                    만원 + 퍼스지원
                    {{ getNumberToKorean(internetSupport.perceSupport) }}만원
                  </div>
                </div>
              </div>
              <div class="sec_1_con">
                퍼스에서 검증된 매장과 함께 진행하는 프로모션으로 매장에서
                지원하는 혜택
                <span v-if="internetTvCheck">
                  {{
                    getNumberToKorean(
                      internetSupport.cashSupport +
                        internetSupport.giftCardSupport,
                    )
                  }}만원(현금{{
                    getNumberToKorean(internetSupport.cashSupport)
                  }}만원+상품권{{
                    getNumberToKorean(internetSupport.giftCardSupport)
                  }}만원)
                </span>
                <span v-else>
                  {{
                    getNumberToKorean(
                      internetSupport.cashSupport +
                        internetSupport.giftCardSupport,
                    )
                  }}만원(현금{{
                    getNumberToKorean(internetSupport.cashSupport)
                  }}만원)</span
                >에 퍼스가 응원금
                <span
                  >{{ getNumberToKorean(internetSupport.perceSupport) }}만원을
                  추가 제공</span
                >합니다!
              </div>
            </div>
            <div class="sec_2">
              <div class="txt_list">
                <div class="title">최소유지조건</div>
                <div class="con">요금제 최소 10개월 유지</div>
              </div>
              <div class="txt_list">
                <div class="title">최소사용기간</div>
                <div class="con">
                  가입후 10개월이내 정지, 연체, 해지 시 환수 <span>‼️</span>🙅‍♂️
                </div>
              </div>
              <div class="txt_list">
                <div class="title">지급방식</div>
                <div class="con">설치인증 당일 전액 입금</div>
              </div>
              <div class="txt_list">
                <div class="title">약정기간</div>
                <div class="con">
                  정지기간 제외 3년이내 해지 시 위약금이 발생
                </div>
              </div>
            </div>
            <div class="sec_3" v-if="internetTvCheck">
              <div
                v-for="(item, index) in internetTvPromotionOption"
                :key="index"
              >
                <div class="txt_list">
                  <div class="title" v-if="index === 0">변경가능옵션</div>
                  <div class="title" v-else></div>
                  <div class="con">
                    {{ index + 1 }}. {{ item.internetName }} +
                    {{ item.tvName }}
                  </div>
                </div>
                <div class="txt_price" :class="{ mb: index === 0 }">
                  > 월 요금 <span>{{ formatNumber(item.totalPrice) }}</span
                  >원, 지원금
                  <span
                    >-{{
                      getNumberToKorean(
                        internetSupport.cashSupport +
                          internetSupport.giftCardSupport +
                          internetSupport.perceSupport -
                          (item.cashSupport +
                            item.giftCardSupport +
                            item.perceSupport),
                      )
                    }}만원</span
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="line_sec" v-if="internetProduct.internetName"></div>
        <div class="item_sec_2" v-if="internetProduct.internetName">
          <div class="item_top">
            <img
              :src="require('@/assets/front/images/new/i_main_my_internet.svg')"
              alt=""
            />
            <div class="item_title">
              {{ internetProduct.internetName }}
            </div>
          </div>
          <div class="item_con" v-html="internetProduct.internetContents"></div>
        </div>
        <div class="line_sec" v-if="internetProduct.wifiName"></div>
        <div class="item_sec_2" v-if="internetProduct.wifiName">
          <div class="item_top">
            <img
              :src="require('@/assets/front/images/new/i_main_my_wifi.svg')"
              alt=""
            />
            <div class="item_title">
              {{ internetProduct.wifiName }}
            </div>
          </div>
          <div class="item_con" v-html="internetProduct.wifiContents"></div>
          <div class="item_con" v-if="internetProduct.wifiImage">
            <img :src="internetProduct.wifiImage" />
          </div>
          <ul class="desc" v-if="internetProduct.wifiSpecs?.length > 0">
            <li v-for="(item, index) in internetProduct.wifiSpecs" :key="index">
              <p class="ttl">{{ item.specTitle }}</p>
              <p class="con">{{ item.specContents }}</p>
            </li>
          </ul>
        </div>
        <div class="line_sec" v-if="internetProduct.tvName"></div>
        <div class="item_sec_2" v-if="internetProduct.tvName">
          <div class="item_top">
            <img
              :src="require('@/assets/front/images/new/i_main_my_tv.svg')"
              alt=""
            />
            <div class="item_title">
              {{ internetProduct.tvName }}
            </div>
          </div>
          <div class="item_con" v-html="internetProduct.tvContents"></div>
        </div>
        <div class="line_sec" v-if="internetProduct.settopName"></div>
        <div class="item_sec_2" v-if="internetProduct.settopName">
          <div class="item_top">
            <img
              :src="require('@/assets/front/images/new/i_main_my_settop.svg')"
              alt=""
            />
            <div class="item_title">
              {{ internetProduct.settopName }}
            </div>
          </div>
          <div class="item_con" v-html="internetProduct.settopContents"></div>
          <div class="item_con" v-if="internetProduct.settopImage">
            <img :src="internetProduct.settopImage" />
          </div>
        </div>
      </div>
    </div>

    <div class="btm_btn">
      <div class="btn_wrap">
        <button class="btn" @click="enterChatRoom" v-if="promotionCheck">
          가입상담하기
        </button>
        <button class="btn" @click="goInternet" v-else>
          견적 받아보기
        </button>
      </div>
    </div>
  </main>
</template>

<script>
import { mapActions as internetMapActions } from '@common/store/modules/internet';
import * as internetTypes from '@common/store/modules/internet/types';

import {
  mapActions as chatMapActions,
  mapGetters as chatMapGetters,
} from '@common/store/modules/chat';
import * as chatActions from '@common/store/modules/chat/types';
import * as chatGetters from '@common/store/modules/chat/getters';

import * as util from '@common/lib/common/utils.js';

export default {
  name: 'ineternetcommerce-itemview',
  description: '인터넷 요금제 상세보기',
  components: {},
  data() {
    return {
      internetProduct: [],
      internetSupport: [],
      isBookmark: 'Y',
      promotionId: this.$route.query.promotionId,
      promotionCheck: false,
      internetTvPromotionOption: [],
      internetTvCheck: false,
      internetSpeed: '',

      isCompleted: false,
    };
  },
  filters: {},
  computed: {
    ...chatMapGetters({
      chatroom_with: chatGetters.CHATROOMS_WITH,
      chatroom: chatGetters.CHATROOM,
    }),
  },
  async created() {
    await this.getItem();
    this.isCompleted = true;
  },
  methods: {
    ...internetMapActions([
      internetTypes.UPDATE_INTERNET_BOOKMARK,
      internetTypes.UPDATE_INTERNET_SEL_PRODUCT,
      internetTypes.FETCH_INTERNET_COMMERCE_PROMOTION_DETAIL,
      internetTypes.FETCH_INTERNET_COMMERCE_PROMOTION_SUPPORT,
      internetTypes.FETCH_INTERNET_COMMERCE_PROMOTION,
    ]),
    ...chatMapActions([
      chatActions.FETCH_CHATROOM_WITH_STORE,
      chatActions.CHATROOMS_WITH_RESET_STATE,
      chatActions.UPDATE_MEMBER_SCREEN_ACTIVED_ALL,
      chatActions.SEND_INTERNETCOMMERCE,
      chatActions.FETCH_CHATROOM_CHATLISTTYPE,
      chatActions.CREATE_CHATROOM,
      chatActions.MESSAGE_NOTICE,
      chatActions.SEND_CHATMESSAGE_PROMOTION,
    ]),
    async getItem() {
      this.promotionId = this.$route.query.promotionId;
      // 프로모션 일 경우
      if (this.promotionId) {
        this.promotionCheck = true;

        const params = {
          id: this.promotionId,
        };

        // 상세 정보
        await this[internetTypes.FETCH_INTERNET_COMMERCE_PROMOTION_DETAIL](
          params,
        ).then(res => {
          console.log(123123123123123123);
          console.log(res);
          this.internetProduct = res.content;
        });

        // 지원금 정보
        await this[internetTypes.FETCH_INTERNET_COMMERCE_PROMOTION_SUPPORT](
          params,
        ).then(res => {
          console.log(111111111);
          console.log(res);
          this.internetSupport = res;

          console.log(this.internetSupport);

          if (this.internetSupport.tvId != '') {
            this.internetTvCheck = true;
          }

          this.internetSpeed = this.internetSupport.internetSpeed;
        });

        // 변경가능옵션 구하기
        await this.fetchInternetCommercePromotion();
      } else {
        this.promotionCheck = false;
        let internetProductSelect = localStorage.getItem(
          'internetProductSelect',
        );
        if (!internetProductSelect) {
          this.internetProduct = new Array();
        } else {
          this.internetProduct = JSON.parse(internetProductSelect);
        }
      }

      console.log('this.internetProduct');
      console.log(this.internetProduct);
    },
    formatNumber(val) {
      if (val >= 0) {
        return util.toCurrency(val);
      } else {
        return val;
      }
    },
    isInternetSpeed(internetSpeed) {
      if (internetSpeed >= 1000) {
        let internetSpeedFormat = internetSpeed / 1000;

        return internetSpeedFormat + 'G';
      } else {
        return internetSpeed + 'M';
      }
    },
    isWeekCost(id, cost, weekendCost) {
      let value = false;
      if ((id === 'KT' || id === 'SKYLIFE') && cost !== weekendCost) {
        value = true;
      }
      return value;
    },
    goInternet() {
      // 상품 견적 카운트 증가
      this.upSelProductCnt();

      this.$router.push({
        name: 'InternetCommerce.Create',
        query: {
          mode: 'MY_INTERNET',
        },
      });
    },
    upSelProductCnt() {
      const item = this.internetProduct;
      const params = {
        telecomId: item.telecomId,
        internetId: item.internetId,
        settopId: item.settopId,
        tvId: item.tvId,
        wifiId: item.wifiId,
      };
      console.log('params :: {}', params);
      this[internetTypes.UPDATE_INTERNET_SEL_PRODUCT](params);
    },
    toggleBookmark() {
      if (this.internetProduct.isBookmark === 'Y') {
        this.internetProduct.isBookmark = 'N';
      } else {
        this.internetProduct.isBookmark = 'Y';
      }
      this.setBookmark();
    },
    setBookmark() {
      let params = { ...this.internetProduct };
      params.procType = this.internetProduct.isBookmark === 'Y' ? 'ON' : 'OFF';
      this[internetTypes.UPDATE_INTERNET_BOOKMARK](params);
      localStorage.setItem(
        'internetProductSelect',
        JSON.stringify(this.internetProduct),
      );
    },
    setShopProfileImg(shopName, shopId) {
      let path = util.setShopProfile(shopName, shopId, '120x120', '25');

      return path;
    },
    getNumberToKorean(number) {
      return util.numberToKorean(number, false);
    },
    async fetchInternetCommercePromotion() {
      const params = {
        promotionType: 'MAIN_PERCE',
      };

      const internetCommercePromotion = await this[
        internetTypes.FETCH_INTERNET_COMMERCE_PROMOTION
      ](params);

      console.log(internetCommercePromotion);

      // 변경가능옵션 ( 인터넷 + TV )
      this.internetTvPromotionOption = internetCommercePromotion.filter(
        (e, i) =>
          e.tvId !== '' &&
          e.internetSpeed === this.internetSpeed &&
          e.id != this.promotionId,
      );

      // this.internetSupport.id

      console.log('fetchInternetCommercePromotion');
      console.log('this.internetTvPromotionOption');
      console.log(this.internetTvPromotionOption);
    },
    async enterChatRoom() {
      var storeId = this.internetSupport.storeId;

      await this[chatActions.CHATROOMS_WITH_RESET_STATE]();
      this[chatActions.FETCH_CHATROOM_WITH_STORE]({
        chatRoomType: 'OneOnOne',
        storeId: storeId,
      }).then(() => {
        let name = 'chat.room';
        const params = {};
        if (this.chatroom_with.count == 0) {
          // name = 'chat.room.create';
          // params.storeId = storeId;
          this[chatActions.CREATE_CHATROOM]({
            chatRoomType: 'OneOnOne',
            memberId: '',
            storeId: storeId,
            estimateId: undefined,
          }).then(() => {
            console.log('this.chatroom');
            console.log(this.chatroom);
            params.uuid = this.chatroom.uuid;

            // 프로모션 상담메시지 생성
            this.chatMessagePromotion(storeId).then(() => {
              this.$router.push({
                name,
                params,
              });
            });
          });
        } else {
          params.uuid = this.chatroom_with.content[0].uuid;

          // 프로모션 상담메시지 생성
          this.chatMessagePromotion(storeId).then(() => {
            this.$router.push({
              name,
              params,
            });
          });
        }
      });
    },
    async chatMessagePromotion(storeId) {
      await this[chatActions.SEND_CHATMESSAGE_PROMOTION]({
        storeId: parseInt(storeId, 10),
        promotionId: parseInt(this.promotionId, 10),
      });
    },
  },
};
</script>

<style></style>
